import { Formik } from "formik";
import { Grid, TextField, FormLabel, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import { ModalFooter } from "../../../../components/common/Modal/ModalFooter";
import { useCategoryStore } from "../../../../hooks/useCategoryStore";
import { useSubcategoryStore } from "../../../../hooks/useSubcategoryStore";
import { useSupplierStore } from "../../../../hooks/useSupplierStore";
import { useSpecificSubcategoryStore } from "../../../../hooks/useSpecificSubcategoryStore";
import { useTypeProductStore } from "../../../../hooks/useTypeProductStore";

const datamoney = [
    { id: 1, code: 'CLP', name: 'PESO', symbol:'CLP', status: '1'},
    { id: 2, code: 'SOL', name: 'SOL', symbol:'S/', status: '1'},
]

const datasupplier = [
    { id: 1, rut: '444323355-5', name_rz: 'Tokio alarm'},
]

const datatypesProducts = [
    { id: 1, code: 'PD', name: 'Productos de consumo'},
    { id: 2, code: 'PN', name: 'Productos de negocios'},
    { id: 3, code: 'PT', name: 'Productos según su duración y tangibilidad'},
]

export const SectionGeneralData: React.FC<any> = (props:any): JSX.Element | any => {

    const { dataGeneral, setDataGeneral, imported, handlePrevSection, handleNextSection, actionproduct, actionimported, clearState } = props;

    const { getCategoriesByCompany } = useCategoryStore();
    const { getSubcategoriesByCategory } = useSubcategoryStore();
    const { getSpecificsubcategoriesBySubCategory } = useSpecificSubcategoryStore();
    const { getSuppliers } = useSupplierStore();
    const { getTypeProducts } = useTypeProductStore();

    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [typesCoins, setTypescoins] = useState<any>([]);
    const [coinSelected, setCoinSelected] = useState<any>('');
    const [categories, setcategories] = useState<any>([]);
    const [categoryselected, setcategoryselected] = useState<any>('');
    const [subcategories, setsubcategories] = useState<any>([]);
    const [subcategoryselected, setsubcategoryselected] = useState<any>('');
    const [specificSubcategories, setspecificSubcategories] = useState<any>([]);
    const [specificSubcategoryselected, setspecificSubcategoryselected] = useState<any>('');
    const [suppliers, setSuppliers] = useState<any>([]);
    const [supplierSelected, setSupplierSelected] = useState<any>('');
    const [types, setTypes] = useState<any>([]);
    const [typeSelected, setTypeSelected] = useState<any>('');

    useEffect(() => {
        getCoinTypeApi();
        getCategoriesApi();
        getSupplierApi();
        getTypesProductApi();
    },[]);

    useEffect(() => {
        if(dataGeneral.idcategory) getSubcategoriesByCategoryApi('', dataGeneral.idcategory);
    },[dataGeneral.idcategory]);

    useEffect(() => {
        if(dataGeneral.idsubcategory) getSpecificsubcategoriesBySubCategoryApi('', dataGeneral.idsubcategory);
    },[dataGeneral.idsubcategory]);

    useEffect(() => {
        if(dataGeneral.idcointype && typesCoins){
            setCustomTypesCoin(dataGeneral.idcointype, typesCoins)
        }
    },[dataGeneral.idcointype, typesCoins])

    const setCustomTypesCoin = (idcointype, typesCoins) => {
        const data = typesCoins.find(type => type.id == idcointype);
        return setCoinSelected(data);
    }

    useEffect(() => {
        if(dataGeneral.idcategory && categories){
            setCustomCategory(dataGeneral.idcategory, categories)
        }
    },[dataGeneral.idcategory, categories])

    const setCustomCategory = (idcategory, categories) => {
        const data = categories.find(category => category.id == idcategory);
        return setcategoryselected(data);
    }

    useEffect(() => {
        if(dataGeneral.idsubcategory && subcategories){
            setCustomSubCategory(dataGeneral.idsubcategory, subcategories)
        }
    },[dataGeneral.idsubcategory, subcategories])
    
    const setCustomSubCategory = (idsubcategory, subcategories) => {
        const data = subcategories.find(subcategory => subcategory.id == idsubcategory);
        return setsubcategoryselected(data);
    }

    useEffect(() => {
        if(dataGeneral.idspecificsubcategory && specificSubcategories){
            console.log(dataGeneral.idspecificsubcategory)
            setCustomSpecificSubCategory(dataGeneral.idspecificsubcategory, specificSubcategories)
        }
    },[dataGeneral.idspecificsubcategory, specificSubcategories])
    
    const setCustomSpecificSubCategory = (idspecificsubcategory, specificsubcategories) => {
        console.log(specificsubcategories)
        const data = specificsubcategories.find(specificSubcategory => specificSubcategory.id == idspecificsubcategory);
        console.log(data)
        return setspecificSubcategoryselected(data);
    }

    useEffect(() => {
        if(dataGeneral.idsupplier && suppliers){
            setCustomSupplier(dataGeneral.idsupplier, suppliers)
        }
    },[dataGeneral.idsupplier, suppliers])
    
    const setCustomSupplier = (idsupplier, suppliers) => {
        const data = suppliers.find(supplier => supplier.id == idsupplier);
        return setSupplierSelected(data);
    }

    useEffect(() => {
        if(dataGeneral.idtype && types){
            setCustomType(dataGeneral.idtype, types)
        }
    },[dataGeneral.idtype, types])
    
    const setCustomType = (idtype, types) => {
        const data = types.find(type => type.id == idtype);
        return setTypeSelected(data);
    }

    const getCoinTypeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = datamoney;
            // const response = await getTypesCoin(search);
            if(!response){
                setTypescoins([]); setLoadingdata(false); return false;
            }else{
                setTypescoins(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSupplierApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getSuppliers({search:search, type:2});
            console.log(response)
            if(!response?.detail){
                setSuppliers([]); setLoadingdata(false); return false;
            }else{
                setSuppliers(response?.detail || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getTypesProductApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getTypeProducts(search);
            if(!response){
                setTypes([]); setLoadingdata(false); return false;
            }else{
                setTypes(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getCategoriesApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getCategoriesByCompany(search);
            if(!response){
                setcategories([]); setLoadingdata(false); return false;
            }else{
                setcategories(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSubcategoriesByCategoryApi = async(search='', idcategory) => {
        try {
            setLoadingdata(true);
            const response = await getSubcategoriesByCategory(search, idcategory);
            if(!response){
                setsubcategories([]); setLoadingdata(false); return false;
            }else{
                setsubcategories(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getSpecificsubcategoriesBySubCategoryApi = async(search='', idsubcategory) => {
        try {
            setLoadingdata(true);
            const response = await getSpecificsubcategoriesBySubCategory(search, idsubcategory);
            if(!response){
                setspecificSubcategories([]); setLoadingdata(false); return false;
            }else{
                setspecificSubcategories(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values:any) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.code && imported) errors.code = "el campo es requerido";
        if(!values.code_erp && !imported) errors.code_erp = "el campo es requerido";

        // if(!values.idcointype) errors.idcointype = "el campo es requerido";
        if(!values.idcategory) errors.idcategory = "el campo es requerido";
        // if(!values.idsupplier) errors.idsupplier = "el campo es requerido";
        if(!values.idtype) errors.idtype = "el campo es requerido";
        return errors;
    }

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    const onSubmit = async(values)  => {
        console.log(values)
        setDataGeneral(values)
        handleNextSection && handleNextSection();
    }

    return (
        <Grid sx={{height:'100%', position: 'relative'}}>
            <Formik initialValues={dataGeneral} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{maxHeight: '65vh', overflowY: 'scroll', paddingRight:'5px'}}>
                                <Grid item container xs={12} spacing={2}>
                                    {
                                        imported && (
                                            <Grid item xs={12} md={6}>
                                                <FormLabel>Código:</FormLabel>
                                                <TextField
                                                    id="code"
                                                    type="text" 
                                                    name="code"
                                                    fullWidth
                                                    size="small"
                                                    value={values.code}
                                                    onChange={handleChange}
                                                    error={errors.code && touched.code ? true : false}
                                                />
                                            </Grid>
                                        )
                                    }
                                    {
                                        !imported && (
                                            <>
                                            {
                                                !imported && (
                                                    <Grid item xs={12} md={6}>
                                                        <FormLabel>Código ERP (*):</FormLabel>
                                                        <TextField
                                                            id="code_erp"
                                                            type="text" 
                                                            name="code_erp"
                                                            fullWidth
                                                            size="small"
                                                            value={values.code_erp}
                                                            onChange={handleChange}
                                                            error={errors.code_erp && touched.code_erp ? true : false}
                                                            inputProps={{ readOnly: actionproduct == 'detail' }}

                                                        />
                                                    </Grid>
                                                )
                                            }
                                            <Grid item xs={12} md={6}>
                                                <FormLabel>Código System:</FormLabel>
                                                <TextField
                                                    id="code_system"
                                                    type="text" 
                                                    name="code_system"
                                                    fullWidth
                                                    size="small"
                                                    value={values.code_system}
                                                    onChange={handleChange}
                                                    error={errors.code_system && touched.code_system ? true : false}
                                                />
                                            </Grid>
                                            </>
                                        )
                                    }
                                    
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Nombre:</FormLabel>
                                        <TextField
                                            id="name"
                                            type="text" 
                                            name="name"
                                            fullWidth
                                            size="small"
                                            value={values.name}
                                            onChange={handleChange}
                                            error={errors.name && touched.name ? true : false}
                                            // helperText={errors.name && touched.name ? errors.name : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Description:</FormLabel>
                                        <TextField
                                            id="description"
                                            type="text" 
                                            name="description"
                                            fullWidth
                                            size="small"
                                            value={values.description}
                                            onChange={handleChange}
                                            error={errors.description && touched.description ? true : false}
                                            // helperText={errors.name && touched.name ? errors.name : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Código de barras:</FormLabel>
                                        <TextField
                                            id="barcode"
                                            type="text" 
                                            name="barcode"
                                            fullWidth
                                            size="small"
                                            value={values.barcode}
                                            onChange={handleChange}
                                            error={errors.barcode && touched.barcode ? true : false}
                                            // helperText={errors.barcode && touched.name ? errors.barcode : ''}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Tipo de moneda:</FormLabel>
                                        <Autocomplete
                                            id="idcointype"
                                            size="small"
                                            value={!!coinSelected ? coinSelected : null}
                                            options={typesCoins || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idcointype && touched.idcointype ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setCoinSelected(newValue)
                                                setFieldValue('idcointype', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Categoria:</FormLabel>
                                        <Autocomplete
                                            id="idcategory"
                                            size="small"
                                            value={!!categoryselected ? categoryselected : null}
                                            options={categories || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idcategory && touched.idcategory ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setcategoryselected(newValue)
                                                setFieldValue('idcategory', newValue ? newValue.id : "");
                                                setsubcategoryselected('');
                                                setspecificSubcategoryselected('');
                                                if(newValue) getSubcategoriesByCategoryApi('', newValue.id)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Subcategoria:</FormLabel>
                                        <Autocomplete
                                            id="idsubcategory"
                                            size="small"
                                            value={!!subcategoryselected ? subcategoryselected : null}
                                            options={subcategories || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idsubcategory && touched.idsubcategory ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setsubcategoryselected(newValue)
                                                setFieldValue('idsubcategory', newValue ? newValue.id : "");
                                                setspecificSubcategoryselected('');
                                                if(newValue) getSpecificsubcategoriesBySubCategoryApi('', newValue.id)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Subcategoria Específica:</FormLabel>
                                        <Autocomplete
                                            id="idspecificsubcategory"
                                            size="small"
                                            value={!!specificSubcategoryselected ? specificSubcategoryselected : null}
                                            options={specificSubcategories || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idspecificsubcategory && touched.idspecificsubcategory ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setspecificSubcategoryselected(newValue)
                                                setFieldValue('idspecificsubcategory', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Proveedor/Producto:</FormLabel>
                                        <Autocomplete
                                            id="idsupplier"
                                            size="small"
                                            value={!!supplierSelected ? supplierSelected : null}
                                            options={suppliers || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name_rz || ''}
                                            isOptionEqualToValue={(option,value)=> option.name_rz === value?.name_rz} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idsupplier && touched.idsupplier ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setSupplierSelected(newValue)
                                                setFieldValue('idsupplier', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Tipo de producto:</FormLabel>
                                        <Autocomplete
                                            id="idtype"
                                            size="small"
                                            value={!!typeSelected ? typeSelected : null}
                                            options={types || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idtype && touched.idtype ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setTypeSelected(newValue)
                                                setFieldValue('idtype', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                    // cancelText={"Atrás"}
                                    // onCancel={onCancel}
                                />
                            </div>
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}